import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/redux/rootState';
import PropertyManager from '../../utils/propertyManager';
import { ensureEnumsLoaded } from '../../utils/appDataLoader';

const EMPTY_ENUMS = {} as Record<string, any[]>;

const useGetEnums = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state: RootState) => state.user);
  const enums = useSelector((state: RootState) => state.enumsReducer);

  useEffect(() => {
    void ensureEnumsLoaded(dispatch, currentUser, enums);
  }, [currentUser, dispatch, enums]);

  try {
    if (
      enums &&
      PropertyManager.isDefined(enums) &&
      Object.keys(enums).some((key) => key !== 'password')
    ) {
      return enums;
    }
  } catch (error) {
    console.error('useGetEnums failed:', error);
  }
  return EMPTY_ENUMS;
};

export default useGetEnums;
